declare module "@mui/material/Divider" {
    interface DividerPropsVariantOverrides {
        solid: true;
    }
}

export default function Divider() {
    return {
        MuiDivider: {
            variants: [
                {
                    props: { variant: "solid" },
                    style: {
                        borderStyle: "solid",
                    },
                },
            ],
            styleOverrides: {
                root: {
                    borderStyle: "dashed",
                    // width: "100%",
                },
            },
        },
    };
}
